
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/4757ec21-150c-4642-9565-bc774ac8fe41.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('4757ec21-150c-4642-9565-bc774ac8fe41');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      